import axios from 'axios';
import { getApiBaseGatewayUrl, getApiBaseUrl } from 'helpers/api';

const baseUrl = getApiBaseUrl();
const baseGatewayUrl = getApiBaseGatewayUrl();

export async function apiOrganismesPAC(payload: any) {
  return axios.post(`${baseUrl}/health/amcPACPolicies`, payload);
}

export function apiTokenDM(payload: any) {
  return axios.post(`${baseUrl}/dm/token`, payload);
}

export function apiPacCategories(payload: { token: any; sessionsId: any }) {
  const headers = {
    accepts: 'application/json',
    'content-type': 'application/json',
    Authorization: `bearer ${payload.token}`,
    sessionid: `${payload.sessionsId}`,
  };
  return axios.post(
    `${baseGatewayUrl}/mobile/v1/api/pac/LoadPacGategorieParams`,
    payload,
    { headers: headers },
  );
}

/* istanbul ignore next */
export function apiCreatePAC(payload: { token: any; sessionsId: any }) {
  const headers = {
    accepts: 'application/json',
    'content-type': 'application/json',
    Authorization: `bearer ${payload.token}`,
    sessionid: `${payload.sessionsId}`,
  };
  return axios.post(
    `${baseGatewayUrl}/mobile/v1/api/pac/addPacDemand`,
    payload,
    { headers: headers },
  );
}
